import React, { Component } from 'react';
import './Test.scss';
import classNames from 'classnames';
import RadioButton from 'components/radio-button/RadioButton';
import Button from 'components/button/Button';
import PropTypes from 'prop-types';
import TestExplain from '../test-explain/TestExplain';

const DIAGRAM_HEIGHT = 400;

class Test extends Component {
  static propsTypes = {
    questionnare: PropTypes.object.isRequired,
  };

  state = {
    answers: [],
    diagramData: {},
    diagramHeight: [],
  };

  onChange(question, answer) {
    this.setState({
      answers: [
        ...this.state.answers.filter(({ question_id }) => question_id !== question.id),
        { question_id: question.id, answer_id: answer.id, result: answer.result },
      ],
    });
  }

  saveAnswers = () => {
    this.setState({ diagramData: this.props.questionnare.getResult(this.state.answers) }, () => {
      this.getDiagramResultHeight();
    });
  };

  back = () => {
    this.setState({ diagramData: {}, answers: [], diagramHeight: [] });
  };

  showDiagram() {
    return Object.keys(this.state.diagramData).length > 0;
  }

  componentDidMount() {
    this.getDiagramResultHeight();
  }

  getPoints = (maxResult) => {
    const arrayPoints = [];
    for (let point = 1; point <= maxResult; point++) {
      arrayPoints.push(point);
    }
    return arrayPoints.map((label, index) => (
      <div
        className="points d-flex align-items-center"
        key={index}
        style={{ height: DIAGRAM_HEIGHT / maxResult }}>
        {label}
      </div>
    ));
  };

  getDiagramResultHeight = () => {
    if (Object.keys(this.state.diagramData).length > 0) {
      setTimeout(() => {
        const diagramHeight = [];
        Object.keys(this.state.diagramData).map((resultColumn) => {
          const result = this.state.diagramData[resultColumn];
          diagramHeight.push((result / this.props.questionnare.maxResult) * DIAGRAM_HEIGHT);
          return null;
        });
        this.setState({ diagramHeight });
      }, 500);
    }
  };

  render() {
    const { questionnare } = this.props;
    const {
      questions,
      questionsTitle,
      questionsDescription,
      resultColumns,
      maxResult,
      rowLabels,
    } = questionnare;
    return (
      <div className="test-container">
        {questionsTitle && !this.showDiagram() ? (
          <h1 className="font-weight-bold">{questionsTitle}</h1>
        ) : null}
        {questionsDescription && !this.showDiagram() ? (
          <h5 className="mb-5 mt-5 question-description">{questionsDescription}</h5>
        ) : null}
        {questions && questions.length > 0 && !this.showDiagram() ? (
          <div>
            {questions.map((question, index) => (
              <div
                className={classNames('question', {
                  empty: !this.state.answers.find(({ question_id }) => question_id === question.id),
                })}
                key={question.id}>
                <div className="question-title d-flex align-start">
                  <span className="mr-1">{`${index + 1}.`}</span>
                </div>
                {question.answers.map((answer) => (
                  <div key={answer.id} className="question-answers">
                    <RadioButton
                      name={`question-${question.id}`}
                      value={answer.id}
                      label={answer.label}
                      onChange={() => this.onChange(question, answer)}
                      checked={
                        !!this.state.answers.find(({ answer_id }) => answer_id === answer.id)
                      }
                    />
                  </div>
                ))}
              </div>
            ))}
            <Button
              className="mt-3"
              disabled={this.state.answers.length !== questions.length}
              onClick={this.saveAnswers}>
              Eredmény megtekintése
            </Button>
          </div>
        ) : null}
        {this.showDiagram() ? (
          <div>
            <div className="diagram-result-container">
              <div className="diagram-result">
                <div
                  className="bar-chart-columns d-flex align-items-end pt-3 pb-3"
                  style={{ height: DIAGRAM_HEIGHT }}>
                  <div className="bar-chart-row-informations d-flex align-items-center flex-column">
                    {rowLabels
                      ? rowLabels.map((label, index) => (
                          <div
                            className="row-label d-flex align-items-center"
                            key={index}
                            style={{ height: DIAGRAM_HEIGHT / rowLabels.length }}>
                            <span>{label}</span>
                          </div>
                        ))
                      : null}
                  </div>
                  <div className="bar-chart-row-informations d-flex align-items-center flex-column-reverse">
                    {maxResult ? this.getPoints(maxResult) : null}
                  </div>
                  {Object.keys(this.state.diagramData).map((resultColumn, index) => {
                    const result = this.state.diagramData[resultColumn];
                    return (
                      <div
                        key={index}
                        className={classNames('bar-chart-column', resultColumn)}
                        style={{
                          height:
                            this.state.diagramHeight.length > 0
                              ? this.state.diagramHeight[index]
                              : 0,
                        }}>
                        <div className="result d-flex align-items-center justify-content-center">
                          {result}
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div className="bar-chart-labels d-flex pt-3 pb-3">
                  {Object.keys(this.state.diagramData).map((resultColumn, index) => {
                    return (
                      <div key={index} className="bar-chart-label">
                        <span className="ml-2 mr-2">
                          <span
                            className={classNames('rotate', {
                              big: resultColumns[resultColumn].length > 16,
                            })}>
                            {resultColumns[resultColumn]}
                          </span>
                        </span>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            <div className="d-flex">
              <TestExplain />
            </div>
            <Button className="mt-3" onClick={this.back}>
              Teszt újratöltése
            </Button>
          </div>
        ) : null}
      </div>
    );
  }
}

export default Test;
